<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-4 col-lg-3 mb-3">
        <validation-provider
          v-slot="{ errors }"
          name="Tipo de Servicio"
          rules="required"
        >
          <custom-drop-down
            v-model="valueServiceType"
            :clearable="false"
            :custom-error-msg="validationMessages.serviceType"
            :disabled="value.id != null"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Tipo de Servicio:"
            :options="serviceTypes"
            placeholder="Seleccione"
            :value="serviceTypeValue"
          />
        </validation-provider>
      </div>
      <div
        v-if="evaluationTypeSwitch && !IsPlanOrAdmissionServiceSelected"
        class="col-sm-12 col-md-4 col-lg-3 mb-3"
      >
        <validation-provider
          v-slot="{ errors }"
          name="evaluación"
          rules="required"
        >
          <custom-drop-down
            v-model="valueEvaluation"
            :custom-error-msg="validationMessages.evaluetion"
            :disabled="value.id != null"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Tipo de Evaluación:"
            :options="evaluetionsTypes"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-3 mb-3">
        <validation-provider
          v-slot="{ errors }"
          name="Servicio"
          rules="required"
        >
          <custom-drop-down
            v-model="valueDisciplineType"
            :clearable="false"
            :custom-error-msg="validationMessages.disciplineType"
            :disabled="value.id != null"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Servicio/Actividad:"
            :options="disciplineTypes"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div
        v-if="modalityTypeSwitch && !IsPlanOrAdmissionServiceSelected"
        class="col-sm-12 col-md-4 col-lg-3 mb-3"
      >
        <validation-provider
          v-slot="{ errors }"
          name="Modalidad"
          rules="required"
        >
          <custom-drop-down
            v-model="valueServiceModalityType"
            :custom-error-msg="validationMessages.serviceModalityType"
            :disabled="value.id != null"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Modalidad:"
            :options="serviceModalityTypes"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div
        v-if="durationTypeSwitch && !IsPlanOrAdmissionServiceSelected"
        class="col-sm-12 col-md-4 col-lg-3 mb-3"
      >
        <validation-provider
          v-slot="{ errors }"
          name="Duración"
          rules="required"
        >
          <custom-drop-down
            v-model="valueTherapyDuration"
            :custom-error-msg="validationMessages.therapyDuration"
            :disabled="value.id != null"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Duración:"
            :options="therapyDurations"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div
        v-if="placeTypeSwitch && !IsPlanOrAdmissionServiceSelected"
        class="col-sm-12 col-md-4 col-lg-3 mb-3"
      >
        <validation-provider
          v-slot="{ errors }"
          name="Tipo de Lugar"
          rules="required"
        >
          <custom-drop-down
            v-model="valueLocationType"
            :custom-error-msg="validationMessages.locationType"
            :disabled="value.id != null"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Tipo de Lugar:"
            :options="locationTypes"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div
        v-if="placeTypeSwitch && !IsPlanOrAdmissionServiceSelected && isSchool"
        class="col-sm-12 col-md-4 col-lg-3 mb-3"
      >
        <validation-provider
          v-slot="{ errors }"
          name="Tipo de Escuela"
          rules="required"
        >
          <custom-drop-down
            v-model="valueSchoolType"
            :custom-error-msg="validationMessages.schoolType"
            :disabled="value.id != null"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Tipo de Escuela:"
            :options="schoolTypes"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div
        v-if="municipalityTypeSwitch && !IsPlanOrAdmissionServiceSelected"
        class="col-sm-12 col-md-4 col-lg-3 mb-3"
      >
        <validation-provider
          v-slot="{ errors }"
          name="Municipio"
          rules="required"
        >
          <custom-drop-down
            v-model="valueMunicipality"
            :custom-error-msg="validationMessages.municipality"
            :disabled="value.id != null"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Municipio:"
            :options="municipality"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>

      <div class="col-sm-12 col-md-4 col-lg-3 mb-3">
        <validation-provider
          v-slot="{ errors }"
          name="costo"
          rules="required|money"
        >
          <custom-input
            v-model="value.amount"
            class="w-50 w-sm-100"
            :custom-error-msg="validationMessages.cost"
            :error="errors[0]"
            label="Costo:"
            prepend-icon="fas fa-dollar-sign"
            type="number"
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from '@/components/common/form/CustomInput';
import CustomDropDown from '@/components/common/form/CustomDropDown';

import DisciplineCategories from '@/utils/constants/disciplineCategories.js';
import DisciplineTypes from '@/utils/constants/disciplineTypeCode.js';
import ServiceTypes from '@/utils/constants/serviceTypes.js';
import locationTypesEnum from '@/utils/constants/locationTypes.js';

import {
  getContractServiceTypes as _getContractServiceTypes,
  getServiceLocationTypes as _getServiceLocationTypes,
  getTherapyDurations as _getTherapyDurations,
  getServiceModalities as _getServiceModalities,
  getServices as _getServices,
  getMunicipalities as _getMunicipalities,
} from '@/modules/provider/api.js';
import {
  getEvaluationtypes as _getEvaluetion,
  getSchoolTypes as _getSchoolTypes,
} from '@/modules/shared/code.api.js';
export default {
  name: 'ServiceInformation',
  components: {
    CustomInput,
    CustomDropDown,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        id: null,
        amount: null,
        description: null,
        serviceType: null,
        serviceTypeId: null,
        serviceTypeName: null,
        disciplineType: null,
        disciplineTypeId: null,
        disciplineTypeName: null,
        serviceModalityType: null,
        serviceModalityTypeId: null,
        serviceModalityTypeName: null,
        locationType: null,
        locationTypeId: null,
        locationTypeName: null,
        schoolTypeId: null,
        schoolTypeName: null,
        therapyDuration: null,
        therapyDurationId: null,
        therapyDurationName: null,
        municipalityId: null,
        municipalityName: null,
      }),
    },
  },
  data() {
    return {
      disciplineTypes: [],
      serviceTypes: [],
      therapyDurations: [],
      municipality: [],
      locationTypes: [],
      schoolTypes: [],
      serviceModalityTypes: [],
      evaluetionsTypes: [],
      validationMessages: {
        municipality: 'Favor seleccionar el municipio',
        serviceType: 'Favor seleccionar el tipo de servicio',
        disciplineType: 'Favor seleccionar el servicio',
        therapyDuration: 'Favor seleccionar la duración',
        locationType: 'Favor seleccionar el tipo de lugar',
        schoolType: 'Favor seleccionar el tipo de escuela',
        serviceModalityType: 'Favor seleccionar la modalidad',
        evaluetion: 'Favor seleccionar tipo de evaluación',
        cost: 'Favor entrar el costo',
      },
      //variables para habilitar inputs
      serviceTypeSwitch: false,
      serviceSwitch: false,
      evaluationTypeSwitch: false,
      modalityTypeSwitch: false,
      durationTypeSwitch: false,
      placeTypeSwitch: false,
      municipalityTypeSwitch: false,
      costTypeSwitch: false,
      valueServiceType: Object.assign(
        {},
        { name: this.value.serviceTypeName, id: this.value.serviceTypeId }
      ),
      valueDisciplineType: Object.assign(
        {},
        { name: this.value.disciplineTypeName, id: this.value.disciplineTypeId }
      ),
      valueTherapyDuration: Object.assign(
        {},
        {
          name: this.value.therapyDurationName,
          id: this.value.therapyDurationId,
        }
      ),
      valueLocationType: Object.assign(
        {},
        { name: this.value.locationTypeName, id: this.value.locationTypeId }
      ),
      valueSchoolType: Object.assign(
        {},
        {
          name: this.value.schoolTypeName,
          id: this.value.schoolTypeId,
        }
      ),
      valueServiceModalityType: Object.assign(
        {},
        {
          name: this.value.serviceModalityTypeName,
          id: this.value.serviceModalityTypeId,
        }
      ),
      valueMunicipality: Object.assign(
        {},
        { name: this.value.municipalityName, id: this.value.municipalityId }
      ),
      valueEvaluation: Object.assign(
        {},
        { name: this.value.evaluationTypeName, id: this.value.evaluationTypeId }
      ),
      valueCost: Object.assign({}, { cost: this.value.cost }),
    };
  },
  computed: {
    IsTherapySelected() {
      return this.value.serviceTypeId == ServiceTypes.Therapy;
    },
    serviceTypeValue() {
      return { name: this.value.serviceTypeName, id: this.value.serviceTypeId };
    },

    IsPlanOrAdmissionServiceSelected() {
      return (
        this.value.disciplineTypeId == DisciplineTypes.Admision ||
        this.value.disciplineTypeId == DisciplineTypes.DiscusionDePlan
      );
    },
    isSchool() {
      return this.value.locationTypeId == locationTypesEnum.Escuela;
    },
  },
  watch: {
    valueServiceType(newValue, oldValue) {
      this.value.disciplineTypeId = null;
      this.value.disciplineTypeName = null;
      this.value.disciplineType = null;

      if (newValue != null) {
        this.value.serviceTypeId = newValue.id;
        this.value.serviceTypeName = newValue.name;

        if (oldValue != null && oldValue.id == 3 && newValue.id != 3) {
          this.resetByServiceType();
        }

        if (newValue.id != ServiceTypes.Consultancy) {
          _getServices(
            [newValue.id],
            [
              DisciplineCategories.ValidForEncuentro,
              DisciplineCategories.ValidForAppointment,
            ]
          ).then((response) => {
            this.disciplineTypes = response.data;
          });
        } else {
          _getServices([newValue.id]).then((response) => {
            this.disciplineTypes = response.data;
          });
        }
      } else {
        this.value.serviceTypeId = null;
        this.value.serviceTypeName = null;

        this.disciplineTypes = [];

        this.resetByServiceType();
      }
    },
    valueDisciplineType(newValue) {
      if (newValue != null) {
        this.value.disciplineTypeId = newValue.id;
        this.value.disciplineTypeName = newValue.name;
      } else {
        this.value.disciplineTypeId = null;
        this.value.disciplineTypeName = null;
      }
    },
    valueTherapyDuration(newValue) {
      this.value.therapyDurationId = newValue.id;
      this.value.therapyDurationName = newValue.name;
    },
    valueLocationType(newValue) {
      this.value.locationTypeId = newValue.id;
      this.value.locationTypeName = newValue.name;
    },
    valueSchoolType(newValue) {
      this.value.schoolTypeId = newValue.id;
      this.value.schoolTypeName = newValue.name;
    },
    valueServiceModalityType(newValue) {
      this.value.serviceModalityTypeId = newValue.id;
      this.value.serviceModalityTypeName = newValue.name;
    },
    valueEvaluationType(newValue) {
      this.value.evaluationTypeId = newValue.id;
      this.value.evaluationTypeName = newValue.name;
    },
    valueCostType(newValue) {
      this.value.amount = newValue;
    },
  },
  created() {
    _getMunicipalities().then((resp) => {
      this.municipality = resp.data;
    });
    _getEvaluetion().then((resp) => {
      this.evaluetionsTypes = resp.data;
    });
    _getContractServiceTypes().then((resp) => {
      this.serviceTypes = resp.data;
    });
    _getSchoolTypes().then((resp) => {
      this.schoolTypes = resp.data;
    });
    _getServiceLocationTypes().then((resp) => {
      this.locationTypes = resp.data.filter(
        (x) => x.id != locationTypesEnum.CAAT
      );
    });
    _getServiceModalities({ forTh: true }).then((resp) => {
      this.serviceModalityTypes = resp.data;
    });
    _getTherapyDurations({ forPei: true }).then((resp) => {
      this.therapyDurations = resp.data;
    });
  },
  async mounted() {
    this.showElementsBydisciplineTypeId();
    if (this.value.serviceTypeId != null) {
      await _getServices(
        [this.value.serviceTypeId],
        [
          DisciplineCategories.ValidForEncuentro,
          DisciplineCategories.ValidForAppointment,
        ]
      ).then((resp) => {
        this.disciplineTypes = resp.data;
      });
    }

    this.value.serviceType = this.serviceTypeValue;
  },
  methods: {
    showElementsBydisciplineTypeId() {
      switch (this.value.serviceTypeId) {
        case ServiceTypes.Therapy:
          this.serviceTypeSwitch = true;
          this.serviceSwitch = true;
          this.placeTypeSwitch = true;
          this.municipalityTypeSwitch = true;
          this.modalityTypeSwitch = true;
          this.durationTypeSwitch = true;

          break;
        case ServiceTypes.IntitialEvaluation:
          this.serviceTypeSwitch = true;
          this.serviceSwitch = true;
          this.municipalityTypeSwitch = true;
          break;
        case ServiceTypes.AdditionalEvaluation:
          this.serviceTypeSwitch = true;
          this.evaluationTypeSwitch = true;
          this.serviceSwitch = true;

          this.municipalityTypeSwitch = true;
          break;
        case ServiceTypes.Consultancy:
          this.serviceTypeSwitch = true;
          this.serviceSwitch = true;
          this.durationTypeSwitch = true;

          break;
      }
    },
    resetByServiceType() {
      this.value.therapyDuration = null;
      this.value.therapyDurationId = null;
      this.value.therapyDurationName = null;
      this.value.locationType = null;
      this.value.locationTypeId = null;
      this.value.locationTypeName = null;
      this.value.serviceModalityType = null;
      this.value.serviceModalityTypeId = null;
      this.value.serviceModalityTypeName = null;
    },
  },
};
</script>
